import { OperatorFunction, pipe } from 'rxjs';
import { map } from 'rxjs/operators';

export function mapDto<T, R>(transform: (dto: T) => R): OperatorFunction<T, R> {
    return pipe(
        map((dto: T) => {
            try {
                return transform(dto);
            } catch (error) {
                console.error('[DTO Transform Error]', error, { dto });
                throw error;
            }
        }),
    );
}
